import React, { useEffect } from "react";

const CanvaSlideshow = () => {
  useEffect(() => {
    // Ensuring the iframe remains interactive on touch devices
    const iframe = document.getElementById("canvaIframe");
    if (iframe) {
      iframe.style.pointerEvents = "auto";
    }
  }, []);

  return (
    <>
    <h1>
        2024 Annual Report
    </h1>
    <div
      style={{
        position: "relative",
        width: "100%", // Full width for responsiveness
        maxWidth: "800px", // Limits max width for better layout
        height: "500px", // Fixed height to match Canva’s aspect ratio
        margin: "auto", // Centers everything
        boxShadow: "0 2px 8px 0 rgba(63,69,81,0.16)",
        overflow: "hidden",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column", // Ensures link is placed below iframe
        alignItems: "center", // Centers everything
        justifyContent: "center",
        touchAction: "manipulation", // Enables better touch control
        WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
      }}
    >
      <iframe
        id="canvaIframe"
        title="Canva Slideshow"
        src="https://www.canva.com/design/DAGc3GWvI6A/6udEaGnf2SLUhdPoLIHnbg/view?embed"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          padding: "0",
          margin: "0",
          objectFit: "cover", // Removes black bars
          overflow: "hidden",
          touchAction: "pan-y", // Allows vertical swipe gestures
          WebkitOverflowScrolling: "touch",
          pointerEvents: "auto",
        }}
        allowFullScreen
        allow="fullscreen"
      ></iframe>

      {/* Centered Link Below Canva Slideshow */}
      <a
        href="https://www.canva.com/design/DAGc3GWvI6A/6udEaGnf2SLUhdPoLIHnbg/view?utm_content=DAGc3GWvI6A&utm_campaign=designshare&utm_medium=embeds&utm_source=link"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "block",
          textAlign: "center",
          marginTop: "15px", // Adds spacing
          color: "#0073e6",
          fontSize: "16px",
          textDecoration: "none",
          fontWeight: "bold", // Makes it look more balanced
        }}
      >
        View on Canva
      </a>
    </div>
    </>
  );
};

export default CanvaSlideshow;
